<template>

    <Header @searchchange="alert"/>
    <div id="layoutSidenav" >
      <div :class="$store.getters.isLoading?'loader':''"></div>
      <Sidebar/>
      <div id="layoutSidenav_content">
        <main>
          <div class="container-fluid">
            <div v-if="$store.getters.user.loggedIn">
            <ol class="breadcrumb mb-4 mt-4">
              <li class="breadcrumb-item "><h4>{{ baslik }}</h4></li>
            </ol>
            </div>

           <router-view :search="search" @baslikchange="baslikChanged" v-if="!$store.getters.isLoading"></router-view>
            <Loading v-if="$store.getters.isLoading"/>
          </div>
        </main>
       <Footer/>
      </div>
    </div>

</template>
<script>
import Sidebar from '@/components/App/Sidebar'
import Header from '@/components/App/Header'
import Footer from '@/components/App/Footer'
import Loading from '@/components/App/Loading'

export default {
  components: {
    Loading,
    Sidebar,
    Header,
    Footer
  },
  methods: {
    alert (v) {
      this.search = v
    },
    baslikChanged (v) {
      this.baslik = v
    }
  },
  data () {
    return {
      search: '',
      baslik: ''
    }
  },
  created () {
    this.$store.dispatch('fetchDersler')
  }
}
</script>
<style>
@import "assets/css/style.css";
body{
  background-color: #002436;
}
.loader {

  background: #3498db; /* Blue */
  width: 100%;
  height: 5px;
  animation: spin 1s linear infinite;
  position: fixed;
  z-index: 10000;
  top:0;

}

@keyframes spin {
  100% { transform: translate(0%); }
  50% {  background: greenyellow; }
  0% { transform: translate(100%); }
}
</style>
